// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3K7E8","questions":"styles_questions__3ON7e","footer":"styles_footer__Us8oO"};